<template>
  <div class="tile">
    <MarketReportsMenu  :isEditable="isEditable"
                        :header="header"
                        @edit="handleEdit"
                        @undo="handleUndo"
                        @save="handleSave" />
    <div  class="tile-content"
          v-if="data && data.length > 0 && waves">
      <DxChart  id="chart"
                :data-source="dataFiltered"
                palette="Violet">

        <DxCommonSeriesSettings type="line"
                                argument-field="x" />

        <DxSeries v-for="(wave, index) in waves"
                  :key="index"
                  :value-field="wave.id"
                  :name="wave.label"
                  :point="{ symbol: 'square', size: 6 }"
                  :color="wave.color"
                  :label="{
                    visible: false,
                    backgroundColor: 'none',
                    displayFormat: '{valueText}%',
                    position: 'inside',
                    customizeText: formatAsPercent,
                    font: {
                      color: 'black',
                      size: 10
                    }
                  }">
        </DxSeries>

        <DxMargin :bottom="20"/>

        <DxArgumentAxis :value-margins-enabled="true"
                        discrete-axis-division-mode="crossLabels"
                        >
                        <!-- :label="{ overlapingBehavior: 'stagger', customizeText: formatAsPercent }" -->
          <DxLabel :customizeText="customizeAxisLabel"
                    overlapingBehavior="stagger" />
          <DxGrid :visible="true"/>
        </DxArgumentAxis>

        <DxValueAxis  :min="valueAxis[0]"
                      :max="valueAxis[1]"
                      :visualRange="valueAxis"
                      visualRangeUpdateMode="keep"
                      :tick-interval="20"
                      overlapping-behavior="none"
                      :label="{ customizeText: formatAsPercent }"
                      position="left">
          <DxConstantLine :value="80"
                          :width="2"
                          color="black"
                          dash-style="solid">
            <DxLabel :text="$t('Webportal.MarketReports.TargetArea')" />
          </DxConstantLine>
        </DxValueAxis>

        <DxTooltip  :enabled="scrollBar.enabled"
                    :customize-tooltip="customizeTooltip"
                    :cornerRadius="4" />

        <DxLegend :visible="false"
                  :enabled="brandMode"
                  vertical-alignment="bottom"
                  horizontal-alignment="right"
                  item-text-position="bottom" />

      </DxChart>
    </div>
    <div v-else class="tile-content market-reports-no-data">{{ $t("Webportal.NoData") }}</div>
  </div>
</template>

<script>
import MarketReportsMixin from '@/mixins/MarketReportsMixin';
import MarketReportsAudiMixin from '@/mixins/MarketReportsAudiMixin';
import {
  DxChart, DxSeries, DxArgumentAxis, DxCommonSeriesSettings,
  DxGrid, DxMargin, DxLegend, DxLabel,
  DxTooltip, DxValueAxis, DxConstantLine,
  //DxExport,  DxScrollBar, DxZoomAndPan
} from 'devextreme-vue/chart';

export default {
  mixins: [MarketReportsMixin, MarketReportsAudiMixin],

  components: {
    DxChart, DxSeries, DxArgumentAxis, DxCommonSeriesSettings,
    DxGrid, DxMargin, DxLegend, DxLabel,
    DxTooltip, DxValueAxis, DxConstantLine
    //, DxExport, DxScrollBar, DxZoomAndPan
  },

  props: {
    brandMode:      { type: Boolean, required: true },
    data:           { type: Array, required: true },
    waves:          { type: Array, required: true },
    waveSettings:   { type: Array, required: true }
  },

  computed: {
    dataFiltered() {
      let result = [];
      for(let item of this.data) {
        const field = this.waveSettings.find(wave => wave.name == item.xBase);
        if (field?.drawData) {
          result.push(item);
        }
      }
      return result;
    }
  },

  methods: {
    handleEdit() {
    },

    customizePointLabel(pointInfo) {
      return pointInfo.value < 50 ? { backgroundColor: 'red' } : { };
    },

    customizeTooltip({ argumentText, point, seriesName }) {
      var realValue = this.multiplyPreserveDecimalPlaces(point.data[seriesName + 'Tooltip']);
      return {
        text: `${seriesName}: ${realValue}%<br/>Wave: ${argumentText}`
      };
    },
    customizeAxisLabel(e) {
      const field = this.waveSettings.find(x => x.name === e.value);
      if (!field || field.drawText)
        return e.valueText;
      return ``;
    }
  }
};

</script>

<style lang="scss" scoped>
#chart {
  height: calc(27vh - 3rem);
}
</style>
